import Button from './Button.component';
import Buttons from './Buttons.component';

export { Button, Buttons };
